module.exports = __webpack_public_path__ + "step5_C2P_aoyama_bridal.4a29af42.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step5_C2P_aoyama_bridal.jpg
// module id = 8aE2
// module chunks = 0